import { TAppState } from '../../types';
import { EPaymentInitSource } from '../../types/microfrontends/paymentWidget';

export const selectPaymentInitSource = (state: TAppState): EPaymentInitSource | null => {
  return state.custom.paymentInitSource;
};
